
/**
 * Created by Jerker Nord on 2019-05-07.
 */

export interface IIconView {
    getState():IconState
    setState(state:IconState):void
    fsIconIsVisible:boolean;
}

export enum IconState {
    disabled = 0,
    enabled = 1,
    activated = 2
}